export default __webpack_public_path__ + "static/media/brasil-logo.17c2e57f.webp";